import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminResponseForTeacherRequestForm, DateFilterWithPagination, TeacherUpdateRequestForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { TeachersUpdateInfoApi } from '../api/teacher-update-info-api';
import { TeacherUpdateInfoRequestModel } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class TeachersUpdateInfoRepository extends Repository {
  constructor(private teachersUpdateInfoApi: TeachersUpdateInfoApi) {
    super();
  }

  getTeachersUpdateInfoRequests(
    filter: DateFilterWithPagination
  ): Observable<DataWithPagination<TeacherUpdateInfoRequestModel[]>> {
    return this.teachersUpdateInfoApi.getTeachersUpdateInfoRequests(filter);
  }

  adminFeedBackForTeachersRequest(form: TeacherUpdateRequestForm): Observable<string> {
    return this.teachersUpdateInfoApi.adminFeedBackForTeachersRequest(form);
  }

  adminResponseForTeacherRequest(form: AdminResponseForTeacherRequestForm): Observable<string> {
    return this.teachersUpdateInfoApi.adminResponseForTeacherRequest(form);
  }
}
